/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgRentalCoverage32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M14.955 9.5H5.754A1.252 1.252 0 004.5 10.754v10.18a5.565 5.565 0 005.566 5.565h3.406a5.564 5.564 0 005.565-5.662l-.027-1.549'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={2}
        strokeWidth={1.5}
        d='M24.133 16l-.003 2.822-1.24 2.029L24.136 23l-1.245 2.366 1.242 2.448c.002.005.003.01.003.016-.003.414-.23.794-.593.993l-3.801 2.091a.5.5 0 01-.741-.438V16h-3l-1.657-9.066a2.333 2.333 0 012.297-2.755h2.591a2.502 2.502 0 012.404-3.18 2.501 2.501 0 012.404 3.18h2.321a2.334 2.334 0 012.297 2.755L27 16h-2.867v0z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M18.5 16h6M11.762 9.999V3.95A1.95 1.95 0 0113.712 2h7.924v2'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M19.04 9.5h5.12'
      />
    </svg>
  );
}

export default SvgRentalCoverage32;
